import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hioDate',
    standalone: true,
})
export class HioDatePipe implements PipeTransform {

  private datePipe = inject(DatePipe);

  constructor(/*@Inject(LOCALE_ID) locale: string, */) {

  }

  transform(value: Date | string | number, format?: string, timezone?: string, locale?: string): string | null {
    if(typeof value == 'string') value = value.replace(/ /g,"T");
    // mediumShort ist kein DatePipe-Preset — sonst wird der String als Muster
    // gelesen (m=Minute, d=Tag, …) und erscheint z.B. als "0e1iu0012ort".
    if (format === 'mediumShort')
      format = 'shortDate';
    return this.datePipe.transform(value, format, timezone, locale);
  }

}

